/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from "@angular/core";
import { AnalyticsService } from "./@core/utils/analytics.service";

// import { NotificationService } from './@core/services/notification/notification.service';
import { NotificationsComponent } from "./pages/components/notifications/notifications.component";

import { UserIdleService } from "angular-user-idle";
import {
  Router,
  Event,
  NavigationStart,
  NavigationEnd,
  NavigationError,
} from "@angular/router";

import { environment } from "../environments/environment";
import { UserService } from "./@core/data/user.service";
import { CookieService } from "ngx-cookie-service";
import { AuthService } from "./@core/services/auth.service";

@Component({
  selector: "ngx-app",
  template:
    "<router-outlet></router-outlet><citi-notification></citi-notification>",
})
export class AppComponent implements OnInit {
  ssoLogoutRedirect: string;

  isProduction: boolean;
  isUAT: boolean;

  constructor(
    private analytics: AnalyticsService,
    private userIdle: UserIdleService,
    private router: Router,
    private userService: UserService,
    private cookieService: CookieService,
    private authService: AuthService
  ) {
    this.isProduction = environment.production;
    this.isUAT = environment.uat;
    this.ssoLogoutRedirect = environment.SSO_LOGOUT_REDIRECT_URL;

    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
        console.log("resetTimer");
        this.userIdle.resetTimer();
      }

      if (event instanceof NavigationEnd) {
        // Hide loading indicator
      }

      if (event instanceof NavigationError) {
        // Hide loading indicator

        // Present error to user
        console.log(event.error);
      }
    });
  }

  ngOnInit(): void {
    console.log("ngOnInit app comp");
    this.analytics.trackPageViews();

    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe((count) => {
      console.log(`timeout in: ${count}`);
    });

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(async () => {
      console.log("Session timed out.");
      // log the user out

      this.authService.logout();
    });

    if (sessionStorage.userInfo) {
      // user logged in at this point, start session timer
      console.log("startWatching");
      this.userIdle.startWatching();
    }

    // this.notificationService
    //         .notification$
    //         .subscribe(message => {
    //           if (message != null) {
    //             console.log(message.message);
    //           }
    //         });
  }
}
